<template>
  <div>
    <form-header />
    <box class="p-5">
      <b-form @submit.prevent="submit()">
        <b-form-group label-for="password">
          <slot name="label">
            <div>
              <label for="password" class="col-form-label pt-0">
                <span>
                  {{ $t('password') }}
                </span>
                <span v-if="errors.password" class="text-danger">
                  - {{ errors.password }}
                </span>
              </label>
            </div>
          </slot>
          <b-form-input
            v-model="form.password"
            size="lg"
            id="password"
            type="password"
            required
          />
          <password-security
            :password="form.password"
            @password-security="setPasswordSecurity"
          />
        </b-form-group>
        <b-form-group label-for="confirm-password">
          <slot name="label">
            <div>
              <label for="confirm-password" class="col-form-label pt-0">
                <span>
                  {{ $t('repeatPassword') }}
                </span>
                <span v-if="confirmPasswordError" class="text-danger">
                  - {{ $t('passNotSame') }}
                </span>
              </label>
            </div>
          </slot>
          <b-form-input
            v-model="confirmPassword"
            size="lg"
            id="confirm-password"
            type="password"
            required
          />
        </b-form-group>
        <b-button
          @click.prevent="submit"
          style="width: 100%;"
          variant="primary"
          class="mt-4"
          type="submit"
          :disabled="disabled"
        >
          {{ $t('resetPassword') }}
        </b-button>
      </b-form>
    </box>
  </div>
</template>

<script>
import FormHeader from './FormHeader.vue';
import PasswordSecurity from '@/components/Forms/PasswordSecurity';

export default {
  components: {
    FormHeader,
    PasswordSecurity
  },

  data() {
    return {
      errors: {},
      form: {
        password: null
      },
      confirmPassword: null,
      strongPassword: false
    };
  },

  computed: {
    passwordConfirm() {
      return this.form.password === this.confirmPassword;
    },

    confirmPasswordError() {
      return (
        this.form.password !== this.confirmPassword && this.confirmPassword
      );
    },

    disabled() {
      return !this.strongPassword || !this.confirmPassword;
    }
  },

  methods: {
    submit() {
      this.errors = {};
      if (this.form.password.length < 1 || !this.passwordConfirm) {
        this.confirmPasswordError = true;
      } else {
        this.resetPassword();
      }
    },

    resetPassword() {
      this.form.token = this.$route.query.token;

      this.$api.auth.post('/auth/password/change-by-token', this.form).then(
        () => {
          this.$router.replace({
            name: 'login'
          });
        },
        e => {
          this.errors = {};
          if (e.response.data.error.errors) {
            this.errors = e.response.data.error
              ? this.$parseAuthErrors(e.response.data.error.errors)
              : {};
          } else {
            e.response.data.error.message &&
              this.$notify('alert', {
                text: e.response.data.error.message,
                variant: 'danger',
                time: 5000
              });
          }
        }
      );
    },

    setPasswordSecurity({ isSecure }) {
      this.strongPassword = isSecure;
    }
  }
};
</script>
